// Types
import { IOption } from './question';

// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

export interface IMeInitializeRequest {
  body: {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    password: string;
  };
}

export interface IMeInitializeResponseMe {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  lastNetworkId: string;
  created: string;
  photoUrl: string | null;
}

export interface IMeInitializeResponseNetwork {
  networkId: string;
  name: string;
  alias: string;
  permission: string;
  photoUrl: string | null;
}

export interface IMeInitializeResponse {
  user: IMeInitializeResponseMe;
  networks: IMeInitializeResponseNetwork[];
}

export function meInitialize(): Promise<IMeInitializeResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.initialize`, {
    method: 'GET'
  });
}

export interface IMeEditRequest {
  body: {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
  };
}

export interface IMeEditResponse extends IMeInitializeResponseMe {}

export function meEdit({ body }: IMeEditRequest): Promise<IMeEditResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.edit`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IGetUserRequest {
  params: { networkId: string };
  query: { userId: string };
}

export interface IGetUserResponse {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  photoUrl: string;
  lastLogin: string;
}

export function getUser({
  params,
  query
}: IGetUserRequest): Promise<IGetUserResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people`, {
    method: 'GET',
    query
  });
}

export interface ICreateUserRequest {
  body: {
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    password: string;
  };
}

export interface ICreateUserResponse {
  userId: string;
}

export function createUser({
  body
}: ICreateUserRequest): Promise<ICreateUserResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/register`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IMeUploadPhotoRequest {
  body: { base64: string };
}

export interface IMeUploadPhotoResponse {
  photoUrl: string;
}

export function meUploadPhoto({
  body
}: IMeUploadPhotoRequest): Promise<IMeUploadPhotoResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.avatar.upload`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IMeDeletePhotoRequest {}

export interface IMeDeletePhotoResponse {}

export function meDeletePhoto(): Promise<IMeDeletePhotoResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.avatar.delete`, {
    method: 'GET'
  });
}

export interface IMeChangePasswordRequest {
  body: {
    oldPassword: string;
    password: string;
  };
}

export interface IMeChangePasswordResponse {}

export function meChangePassword({
  body
}: IMeChangePasswordRequest): Promise<IMeChangePasswordResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.password.change`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IMyNotificationsRequest {}

export interface IMyNotificationsResponse {
  activeFrom: string;
  activeTo: string;
  authorFirstName: string;
  authorLastName: string;
  authorUserId: string;
  authorPhotoUrl: string;
  created: string;
  description: string;
  networkId: string;
  options: IOption[];
  questionId: string;
  recipientCount: number;
  networkName: string;
  commentCount: number;
}

export function myNotifications(): Promise<IMyNotificationsResponse[]> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.notifications`, {
    method: 'GET'
  });
}

export interface IMyNotificationsArchiveRequest {}

export interface IMyNotificationsArchiveResponse {
  activeFrom: string;
  activeTo: string;
  authorFirstName: string;
  authorLastName: string;
  authorUserId: string;
  authorPhotoUrl: string;
  created: string;
  description: string;
  networkId: string;
  questionId: string;
  recipientCount: number;
  networkName: string;
  commentCount: number;
}

export function myNotificationsArchive(): Promise<
  IMyNotificationsArchiveResponse[]
> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.notifications.archive`, {
    method: 'GET',
    query: {
      offset: 0,
      limit: 50
    }
  });
}

export interface IMySettingsEditRequest {}

export interface IMySettingsEditResponse {
  pushNotification: boolean;
  emailNotification: boolean;
}

export function mySettingsGet(): Promise<IMySettingsEditResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.settings.get`, {
    method: 'GET'
  });
}

export interface IMySettingsEditRequest {
  body: {
    pushNotification: boolean;
    emailNotification: boolean;
  };
}

export interface IMySettingsEditResponse {
  pushNotification: boolean;
  emailNotification: boolean;
}

export function mySettingsEdit({
  body
}: IMySettingsEditRequest): Promise<IMySettingsEditResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/me.settings.edit`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/user.ts